import { combineReducers } from 'redux'

import appReducer from './app/reducer'
import { isEqual } from '../utils/javascript'
import jobsReducer from './jobs/reducer'
import userReducer from './user_management/reducer'
import { LOGOUT } from '../utils/constant'

const rootReducer = combineReducers({
  app: appReducer,
  user: userReducer,
  jobs: jobsReducer,
})

const reducer = (state, action) => {
  if (isEqual(action.type, LOGOUT)) {
    state = undefined
  }
  return rootReducer(state, action)
}

export default reducer
